module.exports = __webpack_public_path__ + "static/img/illustratepic_01.43145d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/illustratepic_01.png
// module id = 4CS4
// module chunks = 1